import React, { useState } from "react";
import { Link } from 'react-router-dom';
import companyLogo from "../../../assets/images/ego-logo-01.png";
import profileImg from "../../../assets/images/profile-2.png";
import { Button } from "react-bootstrap";
import { NavLink, useLocation, useNavigate } from "react-router-dom/dist";
import { faAngleDown, faBars } from "@fortawesome/free-solid-svg-icons";
import { Avatar, Drawer, Dropdown } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DownOutlined, UserOutlined } from '@ant-design/icons';
import { Menu } from 'antd';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import LogoutIcon from '@mui/icons-material/Logout';
import { LoginOutlined } from "@mui/icons-material";
import RegisterModal from "../../../pages/components/RegisterModalComponent/RegisterModal";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { ToastAlertSuccess } from "../../../reauseble";



const HeaderBottomComp = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const isActiveShareHoldersRights = location.pathname.startsWith("/ShareHoldersRights");
  const isActiveShareHoldersEducation = location.pathname.startsWith("/ShareHolderEducation");
  const isActiveLibrary = location.pathname.startsWith("/Library");
  const isActiveEService = location.pathname.startsWith("/E-service");

  let userDetails = JSON.parse(localStorage.getItem("user_details"));

  const handleMenuClick = (e) => {
    // message.info('Click on menu item.');
    // console.log(e);
    // navigate(e.path)
  };
  const handleLogout = () => {
    localStorage.clear();
    ToastAlertSuccess("you have Logout Successfully");

    // navigate(e.path)
  };
  let userToken = localStorage.getItem("token");

  const items = [
    // {
    //   label: <Link to='/userprofile'>Profile</Link>,
    //   key: '1',
    //   // icon: <UserOutlined />,
    // },
    // {
    //   label: <Link to='/Library/NewsFeeds'>Newsfeed</Link>,
    //   key: '2',
    // },
    // {
    //   label: 'Company-specific News',
    //   key: '3',
    // },
    // {
    //   label: <Link to='/myInterests'>My Interests</Link>,
    //   key: '4',
    // },
    // {
    //   label: 'Learning Center',
    //   key: '5',

    //   children: [
    //     {
    //       key: '5-1',
    //       label: <Link to='/myCourses'>My Courses </Link>,
    //     },
    //     // {
    //     //   key: '5-2',
    //     //   label: 'Program listing',
    //     // },
    //   ],
    // },
    // {
    //   label: <Link to='/E-service/CompanyMeeting&Announcements'>E-Services </Link>,
    //   key: '6',
    //   children: [
    //     {
    //       key: '6-1',
    //       label: <Link to='/E-service/CompanyMeeting&Announcements'>AGM/EOGM Announcement</Link>,
    //     },
    //     // {
    //     //   key: '6-2',
    //     //   label: 'AGM/EOGM Proceedings',
    //     // },
    //     {
    //       key: '6-3',
    //       label: <Link to='/E-service/E-Voting'>E-Voting</Link>,
    //     },
    //     // {
    //     //   label: <Link to='/MyApplication'>My Application</Link>,
    //     //   key: '6-4',
    //     // },
    //   ],
    // },
    userToken ? {
      label: <Link onClick={handleLogout} to='/'>Logout</Link>,
      key: '7',
      icon: <LogoutIcon />
    } : {
      label: <button style={{ all: "unset" }} onClick={() => setModalShow(true)} >Login</button>,
      key: '7',
      icon: <LoginOutlined />
    },
  ];
  const menuProps = {
    items,
    onClick: handleMenuClick,
  };

  // const shareholderRightsMenu = (
  //   <Menu>
  //     <Menu.Item key="1">
  //       <NavLink to="/option1">Your Rights</NavLink>
  //     </Menu.Item>
  //     <Menu.Item key="2">
  //       <NavLink to="/option2">Videos</NavLink>
  //     </Menu.Item>
  //     <Menu.Item key="3">
  //       <NavLink to="/option3">Webinars</NavLink>
  //     </Menu.Item>
  //     <Menu.Item key="3">
  //       <NavLink to="/option3">Faqs</NavLink>
  //     </Menu.Item>
  //   </Menu>
  // );


  const shareholderRightsMenu = [
    {
      key: '1',
      label: (
        <NavLink to="/ShareHoldersRights/Documents" onClick={() => setOpen(false)}>
          Your Rights
        </NavLink>
      ),
    },
    {
      key: '2',
      label: (
        <NavLink to="/ShareHoldersRights/Videos" onClick={() => setOpen(false)}>
          Videos
        </NavLink>
      ),
    },
    {
      key: '3',
      label: (
        <NavLink to="/ShareHoldersRights/Webinars" onClick={() => setOpen(false)}>
          Webinars
        </NavLink>
      ),
    },
    {
      key: '4',
      label: (
        <NavLink to="/ShareHoldersRights/Faqs" onClick={() => setOpen(false)}>
          FAQs
        </NavLink>
      ),
    },
  ];
  const shareholderEducationMenu = [
    {
      key: '1',
      label: (
        <NavLink to="/ShareHolderEducation/learning" onClick={() => setOpen(false)}>
          E - Learning
        </NavLink>
      ),
    },
    {
      key: '2',
      label: (
        <NavLink to="/ShareHolderEducation/WebinarsandEvents" onClick={() => setOpen(false)}>
          Webinars & Events
        </NavLink>
      ),
    },
    {
      key: '3',
      label: (
        <NavLink to="/ShareHolderEducation/Presentation" onClick={() => setOpen(false)}>
          Presentation
        </NavLink>
      ),
    },
    {
      key: '4',
      label: (
        <NavLink to="/ShareHolderEducation/PICGPodcast" onClick={() => setOpen(false)}>
          PICG Podcast
        </NavLink>
      ),
    },
    {
      key: '5',
      label: (
        <NavLink to="/ShareHolderEducation/GovernanceUpdate" onClick={() => setOpen(false)}>
          Governance Update
        </NavLink>
      ),
    },
  ];
  const libraryMenu = [
    {
      key: '1',
      label: (
        <NavLink to="/Library/Legal&RegulatoryInformation" onClick={() => setOpen(false)}>
          Regulatory Information
        </NavLink>
      ),
    },
    {
      key: '2',
      label: (
        <NavLink to="/Library/UsefulResources" onClick={() => setOpen(false)}>
          Resources
        </NavLink>
      ),
    },
    {
      key: '3',
      label: (
        <NavLink to="/Library/NewsFeeds" onClick={() => setOpen(false)}>
          News Feed
        </NavLink>
      ),
    },
    {
      key: '4',
      label: (
        <NavLink to="/Library/UsefulResources/REPORTS" onClick={() => setOpen(false)}>
          Reports
        </NavLink>
      ),
    },
  ];
  const eServicesMenu = [
    {
      key: '1',
      label: (
        <NavLink to="/E-service/CompanyMeeting&Announcements" onClick={() => setOpen(false)}>
          Company Meeting & Announcements
        </NavLink>
      ),
    },
    {
      key: '2',
      label: (
        <NavLink to="/E-service/E-Voting" onClick={() => setOpen(false)}>
          E Voting
        </NavLink>
      ),
    },
    // {
    //   key: '3',
    //   label: (
    //     <NavLink to="/E-service/Directorship" onClick={() => setOpen(false)}>
    //       Directorship
    //     </NavLink>
    //   ),
    // },
    // {
    //   key: '4',
    //   label: (
    //     <NavLink to="/E-service/AdvisoryServices" onClick={() => setOpen(false)}>
    //       Advisory Services
    //     </NavLink>
    //   ),
    // },
  ];


  const itemsShareholderRights = [
    {
      key: 'sub2',
      label: 'Shareholder Rights',
      // icon: <AppstoreOutlined />,
      children: shareholderRightsMenu
    },
  ];
  const itemsShareholderEducation = [
    {
      key: 'sub2',
      label: 'Shareholder Education',
      // icon: <AppstoreOutlined />,
      children: shareholderEducationMenu
    },
  ];
  const itemsLibrary = [
    {
      key: 'sub2',
      label: 'Library',
      // icon: <AppstoreOutlined />,
      children: libraryMenu
    },
  ];
  const itemsEService = [
    {
      key: 'sub2',
      label: 'Investor Information',
      // icon: <AppstoreOutlined />,
      children: eServicesMenu
    },
  ];

  return (
    <>
      {/* <div className="container"> */}

      <div className="bottom_head">

        <div className="container">
          <div className="inner-wrap">
            <div className="nav">
              <div className="nav-links">

                {/* <div className="logo_wrap">
                  <Link to='/'>
                    <img
                      src={companyLogo}
                      // width="100%"
                      alt='image'
                    />
                  </Link>
                </div> */}
                {/* <Link to='/'> */}
                {/* </Link> */}
                {/* <NavLink exact to="/" activeClassName="active">Home</NavLink> */}

                <Dropdown menu={{ items: shareholderRightsMenu }}
                // trigger={['click']}
                // getPopupContainer={(trigger) => trigger.parentNode}
                >
                  <NavLink to="/ShareHoldersRights/Documents" className={isActiveShareHoldersRights ? "active" : ""}>Shareholder Rights <ArrowDropDownIcon /></NavLink>
                </Dropdown>

                <Dropdown menu={{ items: shareholderEducationMenu }} >
                  {/* <NavLink to="/ShareHolderEducation/learning" activeClassName="active">Shareholder Education<ArrowDropDownIcon /></NavLink> */}
                  <NavLink to="/ShareHolderEducation/learning" className={isActiveShareHoldersEducation ? "active" : ""}>Shareholder Education<ArrowDropDownIcon /></NavLink>
                </Dropdown>

                <Dropdown menu={{ items: libraryMenu }}>
                  <NavLink to="/Library/Legal&RegulatoryInformation" className={isActiveLibrary ? "active" : ""}>Library<ArrowDropDownIcon /></NavLink>
                </Dropdown>

                <Dropdown menu={{ items: eServicesMenu }}>
                  <NavLink to="/E-service/CompanyMeeting&Announcements" className={isActiveEService ? "active" : ""}>Investor Information<ArrowDropDownIcon /></NavLink>
                </Dropdown>

                {/* <NavLink to="/faq" activeClassName="active">FAQ's</NavLink> */}
                {/* <NavLink to="/contact" activeClassName="active">Contact</NavLink> */}

                {/* <Button className="signUp_btn" onClick={()=>navigate("/login")} variant="primary">Sign In</Button> */}
                {/* <Dropdown.Button href={items.path} style={{ width: "auto",".ant-btn":{
                  borderRadius:"50%"
                } }} trigger={"click"} menu={menuProps} placement="bottomRight" icon={
                  <img className="profileIcon" width={"140%"} src={profileImg} />
                  }> */}
                {/* <img className="profileIcon" src={profileImg} /> */}
                {/* <FontAwesomeIcon style={{padding:"0 5px"}} icon={faAngleDown} /> */}
                {/* CDC */}
                {/* </Dropdown.Button> */}
                <Dropdown.Button
                  href={items.path}
                  style={{
                    width: "auto",
                  }}
                  className="custom-dropdown-button"
                  trigger="click"
                  menu={menuProps}
                  placement="bottomRight"
                  // icon={<img className="profileIcon" width="140%" src={profileImg} />}
                  icon={
                    userDetails?.username ?
                      <Avatar size={"large"}>{userDetails?.username.charAt(0).toUpperCase() || "?"}</Avatar>
                      :
                      <img className="profileIcon" width="40px" src={profileImg} />
                  }
                />

              </div>
            </div>

            <div className='col logo_wrap'>
              <div className="logo">

                <Link to='/'>
                  <img
                    src={companyLogo}
                    alt='image'
                  />
                </Link>
              </div>
              <div className='menu_btn'>
                <Button
                  type='primary'
                  className='nav_menu_btn'
                  onClick={() => setOpen(true)}>
                  <FontAwesomeIcon icon={faBars} />
                </Button>
              </div>
              <Drawer
                className='main_menu'
                title='E Governance'
                placement='right'
                onClose={() => setOpen(false)}
                open={open}>
                <div className='nav-links'>
                  {/* <Link to='/' className='nav-link drawer_navLink' onClick={() => setOpen(false)}>Home</Link> */}
                  {/* <Link to='/ShareHoldersRights/Documents' className='nav-link drawer_navLink'>Shareholder Rights</Link> */}
                  <Menu
                    // onClick={()=}
                    // style={{
                    //   width: 256,
                    // }}
                    // defaultSelectedKeys={['1']}
                    // defaultOpenKeys={['sub1']}
                    mode="inline"
                    items={itemsShareholderRights}
                  />
                  <Menu
                    // defaultSelectedKeys={['1']}
                    // defaultOpenKeys={['sub1']}
                    mode="inline"
                    items={itemsShareholderEducation}
                  />
                  <Menu
                    mode="inline"
                    items={itemsLibrary}
                  />
                  <Menu
                    mode="inline"
                    items={itemsEService}
                  />
                  {/* <Link to='/ShareHolderEducation/learning' className='nav-link drawer_navLink'>Shareholder Education</Link>
                  <Link to='/Library/Legal&RegulatoryInformation' className='nav-link drawer_navLink'>Library</Link>
                  <Link to='/E-service/CompanyMeeting&Announcements' className='nav-link drawer_navLink'>E-Service</Link> */}
                  {/* <Link to='/faq' className='nav-link'>FAQ's</Link> */}
                  {/* <Link to='/contact' className='nav-link drawer_navLink' onClick={() => setOpen(false)}>Contact</Link> */}
                  {userToken && <Link onClick={handleLogout} to='/' className='nav-link drawer_navLink'>Logout</Link>}
                  {!userToken && <a onClick={() => setModalShow(true)} className='nav-link drawer_navLink'>Login</a>}
                </div>
              </Drawer>
            </div>
          </div>
        </div>
      </div>
      <RegisterModal
        modalShow={modalShow}
        setModalShow={setModalShow}
      />
      {/* </div> */}
    </>
  );
};

export default HeaderBottomComp;
